// import Masonry from 'masonry-layout/masonry';
import instantsearch from "instantsearch.js";
import {hits, pagination, refinementList, searchBox} from "instantsearch.js/es/widgets";

export default {
  init() {
    if($('body').hasClass('post-type-archive-business-directory')){

      // Update to Production ID/Key when pushing to live
      const options = {
        appId: '6Z7E96AOMV', //dev: D9S80A3AIW
        apiKey: '1bba0902431474069ba87f53963aec2f', //dev: d3b607ad680911a722a475c8584cc158
        indexName: 'wp_posts_business-directory', //dev: wp_posts_business-directory
        urlSync: false,
      }

      const search = instantsearch(options);

      // initialize search box
      search.addWidget(
        searchBox({
          container: '#search-box',
          placeholder: 'SEARCH',
        })
      );

      // initialize hits
      search.addWidget(
        hits({
          container: '#hits-business-directory',
          templates: {
            empty: ``,
            item: `
            <div>
              <div class="container">
                <div class="row pb-4 py-md-4 py-lg-5">

                  <div class="col-12 col-md-4">
                    <div class="row py-4 py-md-0 pt-md-1">
                      <div class="col-3 col-sm-2 col-md-3 pt-md-1 d-flex justify-content-center">
                        {{{ icon }}}
                      </div>
                      <div class="col-9 col-sm-10 col-md-9">
                        <div class="px-1 px-md-2">
                          <h6>{{ post_title }}</h6>
                          <hr class="my-2">
                          <p class="m-0 text-uppercase">{{ taxonomies.business-category }}</p>
                        </div>
                      </div>
                    </div>  
                  </div>

                  <div class="col-12 col-md-4">
                    <ul class="list-unstyled pr-md-3">
                      <li class="d-table pb-xl-2">
                        <i class="d-table-cell fa fa-business fa-map-marker text-success"></i>
                        <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={{ post_title }} {{ address }}">{{ address }}</a>
                      </li>
                      
                      {{{ phone }}}
                      {{{ website }}}
                      {{{ facebook }}}
                      {{{ twitter }}}
                      {{{ instagram }}}
                      {{{ googleplus }}}
                      {{{ linkedin }}}
                    </ul>
                  </div>

                  <div class="col-12 col-md-4 mt-4 mt-md-0">
                    <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={{ post_title }} {{ address }}">
                      <div class="business-map" style="background-image:url('https://maps.googleapis.com/maps/api/staticmap?center={{ location.lat }},{{ location.lng }}&scale=2&zoom=16&size=640x420&maptype=roadmap&markers=scale:2%7C{{ location.lat }},{{ location.lng }}&key=AIzaSyCDfXS_OwfxOTgEuOmsjsi82a4pftaGBLw');"></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            `,
          },

        //   <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={{ post_title }} {{ address }}">
        //   <div class="business-map" style="background-image:url('https://maps.googleapis.com/maps/api/staticmap?center={{ location.lat }},{{ location.lng }}&zoom=16&size=326x145&maptype=roadmap&markers=scale:2%7C{{ location.lat }},{{ location.lng }}&key=AIzaSyCDfXS_OwfxOTgEuOmsjsi82a4pftaGBLw');"></div>
        // </a>

        // <div class="acf-map" data-zoom="16">
        //               <div class="marker" data-lat="{{ location.lat }}" data-lng="{{ location.lng }}">
        //                 <p>{{ address }}</p>
        //                 <div style="color: #ee4823 !important;">
        //                   <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={{ post_title }} {{ address }}">
        //                     <span><u>View on Google Maps</u></span>
        //                   </a>
        //                 </div>
        //               </div>
        //             </div>
        
          transformData: {
            item: (object) => {
              if (object.custom_content){
                object.content = object.custom_content;
              }
              object.content = object.content.split(" ").splice(0, 45).join(" ");

              if(object.taxonomies['business-category'][0] === "Automotive"){
                object.icon = '<i class="fa fa-car fa-4x" aria-hidden="true"></i>';
              } else if(object.taxonomies['business-category'][0] === "Beauty"){
                object.icon = '<i class="fa fa-eye fa-4x" aria-hidden="true"></i>';
              }
              else if(object.taxonomies['business-category'][0] === "Finance"){
                object.icon = '<i class="fa fa-dollar fa-4x" aria-hidden="true"></i>';
              }
              else if(object.taxonomies['business-category'][0] === "Food and Beverage"){
                object.icon = '<i class="fa fa-cutlery fa-4x" aria-hidden="true"></i>';
              }
              else if(object.taxonomies['business-category'][0] === "Health and Wellness"){
                object.icon = '<i class="fa fa-medkit fa-4x" aria-hidden="true"></i>';
              }
              else if(object.taxonomies['business-category'][0] === "Other"){
                object.icon = '<i class="fa fa-industry fa-4x" aria-hidden="true"></i>';
              }
              else if(object.taxonomies['business-category'][0] === "Retail"){
                object.icon = '<i class="fa fa-shopping-cart fa-4x" aria-hidden="true"></i>';
              }
              else if(object.taxonomies['business-category'][0] === "Services"){
                object.icon = '<i class="fa fa-industry fa-4x" aria-hidden="true"></i>';
              }

              if(object.phone){
                object.phone_href = object.phone.replace(/[- )(]/g,'');
                object.phone = '<li class="d-table pb-xl-2"><i class="d-table-cell fa fa-business fa-phone text-success"></i><a href="tel:+1' + object.phone_href + '">' + object.phone + '</a></li>'
              }

              if(object.website){
                object.website = '<li class="d-table pb-xl-2 text-success"><a href="' + object.website + '" target="_blank"><i class="d-table-cell fa fa-business fa-globe text-success"></i>Visit Website</a></li>';
              }

              if(object.facebook){
                object.facebook = '<li class="d-table pb-xl-2 text-success"><a href="' + object.facebook + '" target="_blank"><i class="d-table-cell fa fa-business fa-facebook text-success"></i>Facebook</a></li>';
              }

              if(object.twitter){
                object.twitter = '<li class="d-table pb-xl-2 text-success"><a href="' + object.twitter + '" target="_blank"><i class="d-table-cell fa fa-business fa-twitter text-success"></i>Twitter</a></li>';
              }

              if(object.instagram){
                object.instagram = '<li class="d-table pb-xl-2 text-success"><a href="' + object.instagram + '" target="_blank"><i class="d-table-cell fa fa-business fa-instagram text-success"></i>Instagram</a></li>';
              }

              if(object.googleplus){
                object.googleplus = '<li class="d-table pb-xl-2 text-success"><a href="' + object.googleplus + '" target="_blank"><i class="d-table-cell fa fa-business fa-google-plus text-success"></i>Google+</a></li>';
              }

              if(object.linkedin){
                object.linkedin = '<li class="d-table pb-xl-2 text-success"><a href="' + object.linkedin + '" target="_blank"><i class="d-table-cell fa fa-business fa-linkedin text-success"></i>Linkedin</a></li>';
              }
              

              return object;
            },
          },
        })
      );

      // initialize filters
      search.addWidget(
        refinementList({
          attributeName: 'taxonomies.business-category',
          container: '#refinement-list-business-directory',
          sortBy: ['name:asc'],
        })
      );

      // initialize pagination
      search.addWidget(
        pagination({
          container: '#pagination',
          labels: {
            next: '<i class="fa fa-arrow-right"></i>',
            prev: '<i class="fa fa-arrow-left"></i>',
          },
          maxPages: 5,
          // default is to scroll to 'body', here we disable this behavior
          scrollTo: false,
          showFirstLast: false,
        })
      );

      search.start();

    }
  },
  finalize() {
    // if($('body').hasClass('post-type-archive-newton_events')){
    //   var elem = document.querySelector('.grid');
    //   new Masonry( elem, {
    //     // options
    //     itemSelector: '.grid-item',
    //     columnWidth: 200,
    //   });
    // } 
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js